<template>
    <div class="bubble-area">
        <!--<div class="bubble-box">
            <el-popover
                    trigger="manual"
                    placement="left"
                    popper-class="suspend-box"
                    v-model="isVisible"
                    persistent
            >
                <div class="suspend-box-header">
                    扫码添加小助手，<br/>获取考试信息～
                </div>
                <div class="suspend-box-content">
                    <div class="suspend-box-item">
                        <img src="../../assets/image/qrcode/CACA-Pre.png" alt="CACA-Pre小助手"/>
                        <div class="suspend-item-title">CACA-Pre小助手</div>
                    </div>
                    <div class="suspend-box-item">
                        <img src="../../assets/image/qrcode/CACA-Basic.png" alt="CACA-Basic小助手"/>
                        <div class="suspend-item-title">CACA-Basic小助手</div>
                    </div>
                </div>
                <i class="suspend-close el-icon-circle-close" @click="isVisible=false"></i>
                <div slot="reference" class="bubble-box-item" @click="isVisible=true">
                    <i class="el-icon el-icon-chat-dot-round"></i>
                    <div class="bubble-item-title">小助手</div>
                </div>
            </el-popover>
        </div>-->
        <div class="bubble-box to-top">
            <div class="bubble-box-item" @click="scrollToTop">
                <i class="el-icon el-icon-top"></i>
                <div class="bubble-item-title">回顶部</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BubbleArea",
        data() {
            return {
                isVisible: false,
            }
        },
        mounted() {
            // 确保DOM渲染完成后强制显示
            this.$nextTick(() => {
                this.isVisible = true;
            });
        },
        methods: {
            // 平滑滚动到顶部
            scrollToTop() {
                console.log(111)
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // 平滑滚动效果
                });
            },
        },
    }
</script>

<style scoped lang="scss">

    .bubble-area {
        position: fixed;
        right: 0;
        bottom: 15%;
        /*right: 1.6rem;*/
        /*bottom: 3rem;*/

        .bubble-box {
            border-radius: 0.8rem 0 0 0.8rem;
            border-width: 1px 0px 1px 1px;
            border-style: solid;
            border-color: rgba(0, 0, 0, 0.08);
            background-color: #fff;
            box-shadow: 0 0 2rem rgba(0, 0, 0, 0.15);
            margin-bottom: 0.8rem;
            padding: 0.8rem;

            &:last-child {
                margin-bottom: 0;
            }

            .bubble-box-item {
                padding: 0.8rem;
                text-align: center;
                cursor: pointer;
                margin-bottom: 0.5rem;
                border-radius: 0.8rem;

                &:last-child {
                    margin-bottom: 0;
                }

                &:active {
                    background-color: #f5f5f5;
                }

                .el-icon {
                    font-size: 2rem;
                }

                .bubble-item-title {
                    font-size: 1rem;
                    margin-top: 0.5rem;
                }
            }
        }
    }

    .to-top {
        visibility: hidden;
    }

    .sticky .to-top {
        visibility: visible;
    }

    .suspend-box {
        color: #555555;
        border-radius: 0.5rem;
        background-color: #ffffff;
        box-shadow: 0 0 3.2rem rgba(0, 0, 0, 0.15);

        .suspend-close {
            position: absolute;
            right: 0;
            top: 0;
            transform: translate(20%, -20%);
            font-size: 2.6rem;
            color: #aaaaaa;
            background-color: #ffffff;
            border-radius: 50%;
            padding: 0.2rem;
            cursor: pointer;

            &:active {
                color: var(--color);
            }
        }

        .suspend-box-header {
            color: #555555;
            font-size: 1.35rem;
            padding: 2rem;
            font-weight: bold;
            border-bottom: 1px solid #aaaaaa;
            text-align: justify;
        }

        .suspend-box-content {
            padding: 2rem;

            .suspend-box-item {
                text-align: center;
                margin-bottom: 1rem;

                &:last-child {
                    margin-bottom: 0
                }
            }

            img {
                width: 8rem;
                vertical-align: middle;
            }

            .suspend-item-title {
                font-size: 1.25rem;
                line-height: 1.5;
                margin-top: 0.3rem;
                color: #555555;
            }
        }
    }

    @media (hover: hover) and (pointer: fine) {
        .bubble-area .bubble-box .bubble-box-item:hover {
            background-color: #f5f5f5;
        }

        .suspend-box .suspend-close:hover {
            color: var(--color);
        }
    }
</style>
